export function getUrlVars() {
  const vars = {};
  window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, (m, key, value) => {
    // eslint-disable-line
    vars[key] = value;
  });
  return vars.next;
}

export function addToBrowserStorage(res) {
  localStorage.setItem('access_token', res.access_token);
  localStorage.setItem('refresh_token', res.refresh_token);
  localStorage.setItem('user_id', 1);
  localStorage.setItem('expires_in', res.expires_in);
  localStorage.setItem('jti', res.jti);
  localStorage.setItem('organization', res.organization);
}

export function isOnBoardingRequired(authMode) {
  return authMode === 'eid' || authMode === 'unified' || authMode === 'uaePass';
}
